import L from 'leaflet';
import { showLayerErrorToast } from '../../Toast/toast';

const defaultOptions: L.WMSOptions = {
    layers: 'bicycleroads_c_sthlm,bicycleroads_rc_sthlm',
    format: 'image/png',
    transparent: true,
    noWrap: true,
};

export const bikeRoadsSth = function (mapServerUrl: string, mapTilesVersion: number, options?: L.WMSOptions): L.TileLayer.WMS {
    const layer = L.tileLayer.wms(`${mapServerUrl}wms.axd/sthlm_bicycle_view?v=${mapTilesVersion}`, { ...defaultOptions, ...options });

    layer.on('tileerror', () => {
        showLayerErrorToast('Cykelvägar');
    });

    return layer;
};
